import { createContext, useContext } from "react";

const LangContext = createContext();

export const LangProvider = ({ children }) => {
    const availableLanguages = ["en", "fr", "uk", "pl", "hi", "de"];

    return (
        <LangContext.Provider value={{ availableLanguages }}>
        {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);